import styled from 'styled-components';
import { Link } from '@material-ui/core';
import { Flex } from 'components/base/layout-components';
import { lightColorPalette } from '@linearb/linui-common';

export const StyledPatExplanationWrapper = styled(Flex)`
  width: fit-content;
  height: fit-content;
  padding: 1.5rem;
  background-color: white;
  flex-direction: column;
  border: 1px solid ${lightColorPalette.lbBlue_20};
  border-radius: 0.36rem;
  box-shadow: 0 0 34px 0 rgba(59, 89, 152, 0.2);
`;

export const StyledLinkPat = styled(Link)`
  text-align: center;
`;
